"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  "ui:title": "Ansvarlige personer",
  "ui:options": {
    "sortable": true,
    "spacing": 0.5
  },
  "ui:preview": {
    "select": {
      "title": "title"
    },

    prepare({
      formData
    }) {
      let title;
      let count = formData && formData.length;

      if (count) {
        title = count + " ansvarlige personer";
      }

      return {
        title: title
      };
    }

  },
  "ui:buttons": [{
    "icon": "add",
    "label": "Legg til person"
  }],
  "ui:buttonGroupProps": {
    "fullWidth": true
  },
  "items": {
    "ui:title": "Ansvarlig",
    "ui:field": "primusPerson",
    "ui:buttons": [{
      "icon": "check",
      "type": "save",
      "label": "Lagre og lukk"
    }],
    "ui:preview": {
      "select": {
        "title": "title",
        "description": "description"
      },

      prepare({
        formData,
        schema
      }) {
        const personId = formData.personId,
              role = formData.role;
        let name;

        if (personId && schema.properties.personId.enum && schema.properties.personId.enumNames) {
          const index = schema.properties.personId.enum.indexOf(personId);
          name = schema.properties.personId.enumNames[index] || index;
        }

        return {
          title: name || "Ingen navn",
          description: role || ""
        };
      }

    },
    "ui:options": {
      "editable": true,
      "grid": true,
      "spacing": 2
    },
    "personId": {
      "ui:title": "Ansvarlig person",
      "ui:widget": "autocomplete",
      "ui:placeholder": "Finn ansvarlig person"
    },
    "role": {
      "ui:title": "Ansvarsområde"
    }
  }
};
exports.default = _default;
module.exports = exports.default;